import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ContentContext = createContext(null);

// Icon name -> lucide-react component mapping
import {
  Cloud, Radio, Monitor, Cpu, Box,
  Server, Shield, Smartphone, Layers, Workflow,
} from "lucide-react";

const ICON_MAP = {
  Cloud, Radio, Monitor, Cpu, Box,
  Server, Shield, Smartphone, Layers, Workflow,
};

export const resolveIcon = (iconName) => ICON_MAP[iconName] || Box;

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/content`);
        setContent(data);
      } catch (err) {
        console.warn("Failed to fetch content from API, using static fallback", err);
        setContent(null);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = (section) => {
  const ctx = useContext(ContentContext);
  if (!ctx) return { data: null, loading: true };
  return {
    data: ctx.content?.[section] || null,
    loading: ctx.loading,
  };
};
